var hasBlanket = false;
var hasPillowCover = false;
var blanketQty = 0;
var pillowCoverQty = 0;
var totalQty = 0;


function addQty(product) {
  if (product.product_type == "Beddy's" && product.quantity < 1) {
    product.quantity += 1;
  } else if (product.product_type == "Blankets" && product.selected_variant.inventory_quantity - 1 >= product.quantity) { 
    blanketQty += 1;
    product.quantity += 1;
  } else if (product.product_type == "Pillow Covers" || product.product_type == "Pillows" && product.selected_variant.inventory_quantity - 1 >= product.quantity) {
    pillowCoverQty += 1;
    product.quantity += 1;
  } else if (product.product_type == "Graphics" || product.product_type != "Beddy's" && product.selected_variant.inventory_quantity - 1 >= product.quantity) {
    product.quantity += 1;
  }
}

function subQty(product) {
  if (product.product_type == "Blankets" && product.quantity > 0) { 
    blanketQty -= 1;
    product.quantity -= 1;
  } else if (product.product_type == "Pillow Covers" || product.product_type == "Pillows" && product.quantity > 0) {
    pillowCoverQty -= 1;
    product.quantity -= 1;
  } else if (product.quantity > 0) {
    product.quantity -= 1;
  }
}

document.addEventListener('rebuy.ready', function(event){
  const widget = window.Rebuy.widgets.find((w) => w.id === "66249");
    if (widget != undefined && !hasBlanket && !hasPillowCover) {
      blanketQty = 0;
      pillowCoverQty = 0;
      widget.data.products[0].selected = false;
      widget.data.products.forEach(product => {
        totalQty = 0;
        product.variants.forEach(variant => {
          totalQty += variant.inventory_quantity;
        });
      
        if (product.product_type == "Blankets" && totalQty > 0) {
          blanketQty += product.quantity;
          hasBlanket = true;
        } else if  (product.product_type == "Pillow Covers" && product.variants.length > 0 || product.product_type == "Pillows" && product.variants.length > 0)  {
          pillowCoverQty += product.quantity;
          hasPillowCover = true;
        } else if (product.product_type == "Pillow Covers" || product.product_type == "Blankets" || product.product_type == "Pillows" && product.inventory_quantity <= 0) {
          product.stock = false;
        }
      
        if (totalQty < 1 && product.product_type != 'Graphics') {
          product.selected = false;
          product.quantity = 0;
        }
        
        if (product.variants.length > 0) {
          product.stock = true;
        } else {
          product.stock = false;
        }
      });
    
    
      function checkbox(product) {
        if (product.selected && product.product_type == "Blankets") {
          blanketQty -= product.quantity;
          product.quantity = 0; 
        } else if (product.selected && product.product_type == "Pillow Covers" || product.product_type == "Pillows") {
          pillowCoverQty -= product.quantity;
          product.quantity = 0;
        } else if (!product.selected && product.product_type == "Blankets") {
          product.quantity = 1; 
          blanketQty += product.quantity;
        } else if (!product.selected && product.product_type == "Pillow Covers" || product.product_type == "Pillows") {
          product.quantity = 1;
          pillowCoverQty += product.quantity;
        } else if (product.selected) {
          product.quantity = 0;
        } else if (!product.selected) {
          product.quantity = 1;
        }
      }
      
      if (hasBlanket == false || hasPillowCover == false) {
        widget.data.products.forEach(product => {
          product.selected == false;
          product.quantity == 0;
          document.querySelector(".addtocart").disabled = true;
        });
      }
  }
});